import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingOverlay, Stack } from '@mantine/core';

import { HEADER_HEIGHT, Page, ROUTES } from '@/constants';

import { usePermissions } from './usePermissions';

type RequireAccessProps = {
  page: Page;
  children: ReactNode;
};

const RequireAccess: React.FC<RequireAccessProps> = ({ page, children }) => {
  const { canAccess, loading } = usePermissions();

  if (loading) {
    return (
      <Stack align="center" justify="center" style={{ height: '100%' }}>
        <LoadingOverlay visible top={HEADER_HEIGHT} />
      </Stack>
    );
  }

  if (!canAccess(page)) {
    return <Navigate to={ROUTES.root} replace />;
  }

  return <>{children}</>;
};

export default RequireAccess;
